import React from 'react';
import Utils from '../../utils/Utils';
import * as Constans from './Helpers/Constans';

const getTag = (startTime, endTime) => {
    const tag = {};
    const now = Utils.nowAsTimestampSeconds();
    if(endTime< now){
        //ya paso
        tag.backgroundColor = Constans.PREVIOUS_EVENT_TAG_COLOR;
        tag.label = Constans.PREVIOUS_EVENT_TAG;
    }
    else if(startTime > now){
        tag.backgroundColor = Constans.NEXT_EVENT_TAG_COLOR;
        tag.label = Constans.NEXT_EVENT_TAG;
        //futuro
    }
    else if( startTime<=now && now<endTime){
      // actual
      tag.backgroundColor = Constans.NOW_EVENT_TAG_COLOR;
      tag.label = Constans.NOW_EVENT_TAG;
  }
    return tag;
}

const EventTag = ({ wrapperId, spanId, style, startTime, endTime }) => {
    const tag = startTime && endTime && getTag(startTime, endTime);
    return(
        <div
            className="mini-event-tag-container mini-row"
            id={wrapperId}
            style={style ? style : tag && tag.backgroundColor ? { backgroundColor: tag.backgroundColor } : {} }>
            <span
                id={spanId}
                className="mini-event-tag-label"
            >
                {
                    tag && tag.label
                }
            </span>
        </div>
    );
}

export default EventTag;



// WEBPACK FOOTER //
// ./src/components/PersistentMiniEpg/EventTag.jsx